export default __webpack_public_path__ + "static/media/top_b.e7d326a3.jpg";